import { Injectable } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup
} from '@angular/forms';
import { PurchaseOrderStatus } from 'src/assets/static-data/enums/purchase-order-status.enum';
import { SalesDeliveryStatus } from 'src/assets/static-data/enums/sales-delivery-status.enum';
import { SalesOrderStatus } from 'src/assets/static-data/enums/sales-order-status.enum';
import { SalesQuotationStatus } from 'src/assets/static-data/enums/sales-quotation-status.enum';
import { purchaseOrderStatusLabels } from 'src/assets/static-data/purchaseOrderStatusLabel';
import { SalesDeliveryStatusLabels } from 'src/assets/static-data/SalesDeliveryStatusLabel';
import { salesOrderStatusLabels } from 'src/assets/static-data/salesOrderStatusLabels';
import { SalesQuotationStatusLabels } from 'src/assets/static-data/salesQuotationStatusLabels';
import html2pdf from 'html2pdf.js';

@Injectable({
  providedIn: 'root'
})
export class TransactionsInternalServicesService {
  constructor() {}

  deepCopyFormGroup(control: AbstractControl): AbstractControl {
    if (control instanceof FormGroup) {
      const copiedGroup = new FormGroup({});
      Object.keys(control.controls).forEach((key) => {
        copiedGroup.addControl(key, this.deepCopyFormGroup(control.get(key)!));
      });
      return copiedGroup;
    } else if (control instanceof FormArray) {
      const copiedArray = new FormArray([]);
      control.controls.forEach((childControl) => {
        copiedArray.push(this.deepCopyFormGroup(childControl));
      });
      return copiedArray;
    } else if (control instanceof FormControl) {
      // Create a new FormControl with the same value and validators
      return new FormControl(
        control.value,
        control.validator,
        control.asyncValidator
      );
    } else {
      throw new Error('Unsupported control type');
    }
  }

  //0:salesQuotationStatus,1:salesOrderStatus,2:salesDeliveryStatus,3:purchaseOrderStatus
  getStatusKeyFromValue(value: any, type: number = 0 | 1 | 2) {
    if (value === null || value === undefined) {
      return undefined;
    }
    if (type == 0) {
      const statusKey = Object.keys(SalesQuotationStatus).find(
        (key) =>
          SalesQuotationStatus[key as keyof typeof SalesQuotationStatus] ===
          value
      );

    // If a matching key is found, set it as a string
    if (statusKey) {
      return statusKey as unknown as SalesQuotationStatus; // Assigning the enum value
    }}
    else if(type == 1){
      const statusKey = Object.keys(SalesOrderStatus).find(
        (key) =>
          SalesOrderStatus[key as keyof typeof SalesOrderStatus] === value
      );
      if (statusKey) {
        return statusKey as unknown as SalesOrderStatus; // Assigning the enum value
      }
    } else if (type == 2) {
      const statusKey = Object.keys(SalesDeliveryStatus).find(
        (key) =>
          SalesDeliveryStatus[key as keyof typeof SalesDeliveryStatus] === value
      );
      if (statusKey) {
        return statusKey as unknown as SalesDeliveryStatus; // Assigning the enum value
      }
    }
    else if (type == 3) {
      const statusKey = Object.keys(PurchaseOrderStatus).find(
        (key) =>
          PurchaseOrderStatus[key as keyof typeof PurchaseOrderStatus] === value
      );
      if (statusKey) {
        return statusKey as unknown as PurchaseOrderStatus; // Assigning the enum value
      }
    }

    return null; // Return null if no matching key is found
  }

  //0:salesQuotationStatus,1:salesOrderStatus,2:salesDeliveryStatus,3:purchaseOrderStatus
  getStatusClasses(
    status: string,
    type: number = 0 | 1 | 2
  ): { textClass: string; bgClass: string } | undefined {
    if (type == 0) {
      const statusLabel = SalesQuotationStatusLabels.find(
        (label) => label?.key === status?.toString()
      );
      return statusLabel
        ? { textClass: statusLabel.textClass, bgClass: statusLabel.bgClass }
        : undefined;
    } else if (type == 1) {
      const statusLabel = salesOrderStatusLabels.find(
        (label) => label?.key == status?.toString()
      );
      return statusLabel
        ? { textClass: statusLabel.textClass, bgClass: statusLabel.bgClass }
        : undefined;
    } else if (type == 2) {
      const statusLabel = SalesDeliveryStatusLabels.find(
        (label) => label?.key === status?.toString()
      );
      return statusLabel
        ? { textClass: statusLabel.textClass, bgClass: statusLabel.bgClass }
        : undefined;
    }
    else if (type == 3) {
      const statusLabel = purchaseOrderStatusLabels.find(
        (label) => label?.key === status?.toString()
      );
      return statusLabel
        ? { textClass: statusLabel.textClass, bgClass: statusLabel.bgClass }
        : undefined;
    }
  }

  transformDateFormat(dateString: string) {
    //const dateString = "2024-11-05 13:31:19";  // Original date string

    // Split into date and time parts
    const [datePart, timePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    // Create the Date object (note: months are 0-based in JavaScript Date)
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  generatePdf(hiddenReport:any): void {
    if (hiddenReport) {
      // Here, you can access hiddenReport.nativeElement or pass its data to html2pdf
      const reportContent = hiddenReport.getReportElement(); // Assuming a method to get the content from your child component
      const options = {
        margin: [0.3,0,0.2,0],
        filename: 'document.pdf',
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      };

      html2pdf().from(reportContent).set(options).toPdf().get('pdf').then
      ((pdf:any)=> {
      const totalPages = pdf.internal.getNumberOfPages();
      // Add page numbers (optional)
      for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFont("Amiri");
      pdf.setFontSize(11); // Set font size
      pdf.text('Page ' + i + ' of ' + totalPages, 
      pdf.internal.pageSize.width-7.75, pdf.internal.pageSize.height -0.25);
      }
      }).save();
    }
  }
}
